import {
  CHECKACTIVO_ERROR,
  CHECKACTIVO_LOADING,
  CHECKACTIVO_SUCCESS,
  CHECKACTIVO_RESET,
  RESET_CONTEXT,
} from "../ActionTypes";

import checkActivoInitialState from "../initialStates/checkActivoInitialState";

const checkActivo = (state, { payload, type }) => {
  switch (type) {
    case CHECKACTIVO_LOADING:
      return {
        ...state,
        checkActivo: {
          ...state.checkActivo,
          error: false,
          loading: true,
        },
      };
    case CHECKACTIVO_SUCCESS:
      return {
        ...state,
        checkActivo: {
          ...state.checkActivo,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case CHECKACTIVO_ERROR:
      return {
        ...state,
        checkActivo: {
          ...state.checkActivo,
          error: payload,
          loading: false,
        },
      };

    case CHECKACTIVO_RESET:
      return checkActivoInitialState;
    case RESET_CONTEXT:
      return checkActivoInitialState;

    default:
      return state;
  }
};

export default checkActivo;
